import React from 'react'
import { Button } from '@material-ui/core'

function MainButton({children, ...props}) {
    return (
        <Button size="large" {...props} fullWidth variant="contained" color="secondary">{children}</Button>
    )
}

export default MainButton